import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./LoadDetails.scss"
import messages from '../../assets/i18n';
import { HeaderActions, 
	FooterActions, 
	ToastMessage, 
	ButtonStandard, 
	LoadingSpinner, 
	OrdersInLoadModal, 
	DateLabel} from '../../components';
import ItemList from "../../containers/ItemList/ItemList";
import { Creators as actionFreeGates } from '../../store/ducks/freeGates'
import { Creators as actionLoad } from '../../store/ducks/load'
import getMessageError from '../../utils/getMessageError';
import havePermissionTo from "../../utils/havePermission";

function LoadDetails(props) {
	const dispatch = useDispatch();
	const loadDetails = useSelector(state => state.load.loadDetails);
	const loadId = useSelector(state => state.load.loadId);
	const loadDelete = useSelector(state => state.load.loadDelete)
	const freeGates = useSelector(state => state.freeGates);
	const scheduling = useSelector(state => state.scheduling);
	
	const myPermissions = useSelector(state => state.authorization.permissions);
	const lang = useSelector(state => state.language.name);
	const loadError = useSelector(state => state.load.loadError);
	const schedulingError = useSelector(state => state.scheduling.schedulingError);
	const loadSuccess = useSelector(state => state.load.loadSuccess);
	const schedulingSuccess = useSelector(state => state.scheduling.schedulingSuccess);
	const [modalShow, setModalShow] = useState(false);

	const [removeOrderButton, setRemoveOrderButton] = useState(false);
	const [removeLoadButton, setRemoveLoadButton] = useState(false);
	const [arrChecked, setArrChecked] = useState([]);
	const [disableAdminActions, setDisableAdminActions] = useState(true);
	const [toastMessage, setToastMessage] = useState('');
	const [schedule, setSchedule] = useState(false);
	const [cancelSchedule, setCancelSchedule] = useState(false);
	const [toastClass, setToastClass] = useState('');
	const [show, setShow] = useState(false);
	const [messageCode,setMessageCode] = useState('');

	const goScheduling = () => props.history.push('/scheduling');
	
	const canSchedule = () => {
		setSchedule(true);
	
		loadDetails.pedidos.forEach(pedido => {
			if(pedido.status !== 'A'){
				setSchedule(false);
				setMessageCode('scheduling013');
			}
		});
	};
	
	const canCancelSchedule = () => {
		setCancelSchedule(true);
	
		loadDetails.pedidos.forEach(pedido => {
			if(pedido.status === 'D' || pedido.status === 'C'){
				setCancelSchedule(false);
			}
			
		});
	};

	const verifyCheckedArr = () => {
		let returnValue = false

		loadDetails.pedidos.forEach(pedido => {
			// Pedidos entregues não podem ser cancelados
			if(pedido.status === 'D'){
				if (arrChecked.length > 0) {
					arrChecked.forEach(checked => {
						if (pedido.numero === checked) {
							returnValue = true
						}
					})
				}
			}
			
		});
		return returnValue
	};

	const canDeleteLoad = () => {
		let returnValue = false

		loadDetails.pedidos.forEach(pedido => {
			// Pedidos entregues não podem ser cancelados
			if(pedido.status === 'D'){
				returnValue = true
			}
			
		});
		return returnValue
	};
	
	useEffect(() => {
		if(loadId) {
			dispatch({
				type: "GET_LOAD_DETAILS",
				loadId: loadId
			});
			dispatch( {type: "CLEAN_GATES"});
			dispatch({type: "MODAL_CLEAN_ORDERS"});
		}
		// eslint-disable-next-line
	}, [loadId, scheduling]);

	useEffect(() => {
		return () => {
			dispatch(actionLoad.cleanLoadDetails());
		};
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		dispatch(actionFreeGates.cleanGates());
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if(loadDetails !== undefined && loadDetails !== null) {
			canSchedule();
			canCancelSchedule();

			if (loadDetails.idAgendamento) {
				if (havePermissionTo("admin_alter_load_permissions", myPermissions)) {
					setDisableAdminActions(false)
				} else {
					setDisableAdminActions(true)
				}
			} else {
				setDisableAdminActions(false)
			}
		}
		dispatch({
			type: "LOAD_DELETE_ORDER",
			payload: null
		});
		setRemoveOrderButton(false);
		// eslint-disable-next-line
	}, [loadDetails])

	useEffect(() => {
		setRemoveLoadButton(false)

		if (loadDelete) {
			setTimeout(() => {
				props.history.push('/main');

				dispatch({
					type: "LOAD_DELETE",
					loadId: null
				});

			}, 500);
		}
	// eslint-disable-next-line
	}, [loadDelete])

	const getMessage = (message) => {
		if(message.includes(`[${lang}]`)){
			return message.split(`[${lang}]`)[1].split(';')[0];
		}else {
			return messages[lang].messageErrorScheduling.default;
		}
	}

	useEffect(() => {
		if (freeGates.freeGates.portoes && schedule === true) {
			goScheduling()
		} else if (freeGates.error) {
			setShow(true);
			setToastMessage(freeGates.error ? getMessage(freeGates.error) : '');
			setToastClass('toast-error');
		} 
	// eslint-disable-next-line
	}, [freeGates, scheduling])

	useEffect(() => {
		if(loadError !== null) {
			if(loadError.error === true) {
				let messageCode = getMessageError(loadError.data.message);
				setShow(true);
				setToastMessage( messages[lang].messagesCode[messageCode]);
				setToastClass('toast-error');
				dispatch({ type: "SET_LOAD_ADD_ERROR", payload:{ error: false }});
			}
		}

		if(loadSuccess !== null) {
			if(loadSuccess.success === true){
				let messageCode = 'loadDetails001';

				if( loadSuccess.type === 'save' ){
					messageCode = 'loadDetails001';
				} else {
					if(loadSuccess.type === 'delete'){
						messageCode = 'loadDetails003';
					}
				}

				setShow(true);
				setToastMessage( messages[lang].messagesCode[messageCode]);
				setToastClass('toast-success');
				dispatch({ type: "SET_LOAD_ADD_SUCCESS", payload:{ sucess: false }});
			}
		}
		// eslint-disable-next-line
	},[loadError, loadSuccess])
	
	useEffect(() => {
		if(schedulingError !== null){
			if(schedulingError.error === true){
				let messageCode = getMessageError( schedulingError.data.message);
				setShow(true);
				setToastMessage( messages[lang].messagesCode[messageCode]);
				setToastClass('toast-error');
				dispatch({ type: "SCHEDULING_ERROR", payload:{ error: false }});
			}
		}

		if(schedulingSuccess !== null) {
			if(schedulingSuccess.success === true){
				
				let messageCode = 'scheduling001';

				if(schedulingSuccess.type === 'save' ){
					messageCode = 'scheduling001';
				} else {
					if(schedulingSuccess.type === 'update' ){
						messageCode = 'scheduling002';
					} else {
						if(schedulingSuccess.type === 'delete'){
							messageCode = 'scheduling003';
						}
					}
				}

				setShow(true);
				setToastMessage( messages[lang].messagesCode[messageCode]);
				setToastClass('toast-success');
				dispatch({ type: "SCHEDULING_SUCCESS", payload:{ sucess: false }});
			}
		}
		// eslint-disable-next-line
	},[schedulingError, schedulingSuccess])

	const removeOrder = () => {
		setRemoveOrderButton(true);

		dispatch({
			type: "DELETE_ORDER_LOAD",
			payload: {
				loadId: loadId,
				orderlist: arrChecked,
			}
		});
			setArrChecked([]);
		dispatch({
			type: "LOAD_DELETE_ORDER",
			payload: null
		});
	}

	const deleteLoad = () => {
		setRemoveLoadButton(true);
		dispatch({
			type: "DELETE_LOAD",
			loadId: loadId
		});
	}

	const modalHide = () => {
		setModalShow(false);
		dispatch({ type: "MODAL_CLEAN_SELECT_ORDERS" });
	}

	const handleChecked = () => {
		setModalShow(true);
		// if (ordersModal.ordersModal === null) {
			dispatch({
				type: "GET_ORDERS_MODAL",
				idCd: loadDetails.idCd,
				idCalendarioComercial: loadDetails.idCalendarioComercial,
				fornecedorId: loadDetails.pedidos[0].fornecedorId
			});
		// }
	}

	const scheduleLoad = () => {
		if(schedule === true){
			dispatch({ type: "MODAL_CLEAN_ALL" });
			dispatch({ type: "CLEAN_GATES" });
			dispatch({ type: "GET_FREE_GATES", payload: loadId });
		} else {
			setShow(true);
			setToastMessage( messages[lang].messagesCode[messageCode]);
			setToastClass('toast-error');
		}
	}
	const scheduleCancel = () => {
		dispatch({ type: "MODAL_CLEAN_ALL" });
		dispatch({ type: "CLEAN_GATES" });
		dispatch({ type: "CANCEL_SCHEDULING", payload: loadDetails });
	}

	const pageBack = () => {
		dispatch({ type: "MODAL_CLEAN_ALL" });
		dispatch({ type: "LOAD_ID_CLEAN" });
		props.history.push('/main');
	}

	const ButtonGroupRight = () => {
		
		return havePermissionTo("scheduling", myPermissions) 
			? 	<>
					<ButtonStandard
						id="load_schedule_cancel_button"
						text={messages[lang].scheduleLoadCancel}
						textClass="text-3"
						isLoading={freeGates.loading}
						className="btn btn-primary px-3 py-2 btn-outline-light"
						disabled={!haveScheduling() || cancelSchedule === false}
						onClick={() => scheduleCancel()}
					/>
					<ButtonStandard
						id="load_schedule_load_button"
						text={haveScheduling() ? messages[lang].scheduleLoadUpdate : messages[lang].scheduleLoad}
						textClass="text-3"
						isLoading={freeGates.loading}
						className="btn btn-primary btn-light px-3 py-2"
						onClick={() => scheduleLoad()}
					/>
				</>  
				:
				<></> 
	}
	
	const ButtonGroupLeft = () => {
    return <>
			<ButtonStandard
				id="load_add_order_button"
				text={messages[lang].includeOrders}
				textClass="text-3"
				className="btn btn-primary px-3 py-2 btn-outline-light"
				disabled={cancelSchedule === false || disableAdminActions}
				onClick={() => handleChecked()}
			/>
      <ButtonStandard
				id="load_remove_orders_button"
				text={messages[lang].deleteOrders}
				textClass="text-3"
				disabled={arrChecked.length <= 0 || verifyCheckedArr() || disableAdminActions}
				isLoading={removeOrderButton}
				className="btn btn-primary px-3 py-2 btn-outline-light"
				onClick={() => removeOrder()}
			/>
			<ButtonStandard
				id="load_remove_load_button"
				text={messages[lang].deleteLoad}
				textClass="text-3"
				isLoading={removeLoadButton}
				className="btn btn-danger px-3 py-2"
				disabled={canDeleteLoad() || disableAdminActions}
				onClick={() => deleteLoad()}
			/>
    </>
	}

	const headers = [
		'',
		messages[lang].Order,
		messages[lang].numberPieces,
		messages[lang].numberVolumes,
		messages[lang].status
	];

	let orderListTable = [];
	if(loadDetails) {
		orderListTable = loadDetails && loadDetails.pedidos.map(pedido => (
			[
				{
					checkbox: {
						id: pedido.numero,
						arrChecked: arrChecked,
						setArrChecked: setArrChecked
					}
				},
				pedido.numero,
				pedido.qtCompra,
				pedido.qtVolumes,
				messages[lang].statusOrder[pedido.status],
			]
		));
		orderListTable = [...orderListTable, 
		[
			'',
			'',
			{
				text: messages[lang].totalPieces + ': ' + loadDetails.totalPecas,
				className: 'bg-color-primary py-2 text-3 font-weight-bolder',
				maxLength: 40,
			},
			{
				text: messages[lang].totalVolumes + ': ' + loadDetails.totalVolumes,
				className: 'bg-color-primary py-2 text-3 font-weight-bolder',
				maxLength: 40,
			},
			'',
		]];
	}

	const titlePage = messages[lang].loadDetailsTitle;

	const haveScheduling = () => {
		
		return (
		loadDetails.portao !== 0 && loadDetails.portao !== null
	)}

	if (loadDetails === null || loadDetails === "") {
		return (
			<Container>
				<Row className="justify-content-center mt-5">
					<LoadingSpinner />
				</Row>
			</Container>
		)
	} else {
		return (
				<div className="load-details-page">
					<ToastMessage 
						show={show} 
						setShow={setShow} 
						message={toastMessage}
						toastClass={toastClass} />
					<HeaderActions 
						pageBack={pageBack}
						titlePage={titlePage} />
			
					<Container className="mt-5 mb-5">
						<Row className="justify-content-between">
							<Col xs={2}>
								<Col className="rounded-top bg-color-primary py-2">
									<span className="text-3 font-weight-bolder">{messages[lang].numberLoads}</span>
								</Col>
								<Col className="rounded-bottom bg-color-secondary py-2 mt-1">
									<span className="text-3">{loadDetails.idCarga}</span>
								</Col>
							</Col>
							<Col xs={2}>
								<Col className="rounded-top bg-color-primary py-2">		
									<span className="text-3 font-weight-bolder">{messages[lang].businessWeek}</span>
								</Col>
								<Col className="rounded-bottom bg-color-secondary py-2 mt-1">
									<span className="text-3">{loadDetails.semanaComercial}</span>
								</Col>
							</Col>
							<Col xs={3}>
								<Col className="rounded-top bg-color-primary py-2">
									<span className="text-3 font-weight-bolder">{messages[lang].distributionCenter}</span>
								</Col>
								<Col className="rounded-bottom bg-color-secondary py-2 mt-1">
									<span className="text-3">{loadDetails.centroDistribuicao}</span>
								</Col>
							</Col>
							<Col xs={4}>
								<Col className="rounded-top bg-color-primary py-2">		
									<span className="text-3 font-weight-bolder">{messages[lang].scheduling}</span>
								</Col>
								<Col className="rounded-bottom bg-color-secondary py-2 mt-1">
									{ haveScheduling() ? 
									<span className="text-3"><strong>{messages[lang].gates}:</strong> {loadDetails.nomePortao}<br />
											<strong>{messages[lang].deliveryDate}:</strong> {<DateLabel date={loadDetails.dtEntrega} />}<br />
											<strong>{messages[lang].deliveryHour}:</strong> {loadDetails.horaEntrega}</span>
										: 
											messages[lang].messageErrorLoad.notScheduling
									}
									</Col>
							</Col>
						</Row>
					</Container>

					<Container className="mb-5 pb-5">
						<ItemList titleTable={messages[lang].numberLoads} header={headers} listTable={orderListTable} />
					</Container>
					
					<OrdersInLoadModal
						show={modalShow}
						onHide={() => modalHide()}
						load={loadDetails.idCarga}
					/>

					<FooterActions ButtonGroupLeft={ButtonGroupLeft} ButtonGroupRight={ButtonGroupRight} />

				</div>
		)
	}
}

export default withRouter(LoadDetails);